import { Component, ViewChild } from '@angular/core';
import { PoslovniImenik, ApiClientService } from '../../services/api-client.service';
import { CacheService } from '../../services/cache.service';

@Component({
  selector: 'app-poslovni-imenik',
  templateUrl: './poslovni-imenik.component.html',
  styleUrls: ['./poslovni-imenik.component.scss']
})
export class PoslovniImenikComponent {
  @ViewChild('poslovniImenikGrid', { static: false }) poslovniImenikGrid: any;

  gridData: PoslovniImenik[] = [];
  loading = false;
  loadPanelPosition = { of: '#poslovniImenikGrid' };

  constructor(
    private apiClient: ApiClientService,
    private cache: CacheService
  ) { }

  ngOnInit() {
    this.loadPoslovniImenik();
  }

  async loadPoslovniImenik() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.poslovniImenik();
    } catch (error) {
      console.error('Error loading poslovni imenik:', error);
    } finally {
      this.loading = false;
    }
  }

  onRefreshClick() {
    this.loadPoslovniImenik();
  }
}
